import React from "react";
import LinkedInAutomationFilter from "./LinkedInAutomationFilter";
import LinkedInAutomationAnalytics from "./LinkedInAutomationAnalytics";
import LinkedInAutomationInsights from "./LinkedInAutomationInsights";

const LinkedInAutomationModule = () => {
  return (
    <div className="reportsModuleWrapper">
      <div className="reportsHeader">
        <div className="reportsTitle">LinkedIn Automation</div>
        <LinkedInAutomationFilter />
      </div>
      <div className="reportsContent">
        <LinkedInAutomationAnalytics />
        <LinkedInAutomationInsights />
      </div>
    </div>
  );
};

export default LinkedInAutomationModule;
